/* eslint-disable react/no-unknown-property */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable nordic/no-script-tags */
/* eslint-disable max-len */
/* eslint-disable nordic/i18n-jsx-no-literals */
/**
 * Module dependencies
 */
const React = require('react');
const PropTypes = require('prop-types');
const Style = require('nordic/style');
const Script = require('nordic/script');
const injectI18n = require('nordic/i18n/injectI18n');
const { Library } = require('dx-devsite-markdown');
const ProgressIndicatorCircular = require('@andes/progress-indicator-circular');
const PageContainer = require('../../../components/PageContainer');
const MenuUtils = require('../../../../utils/menu');
const {
  onPageLoad,
  goToLocation,
} = require('../../../common/GuidesActions');
const Landings = require('../../../components/landings');
const AnchoredMenu = require('../../../components/AnchoredMenu');
const AnchoredLanding = require('../../../components/AnchoredLanding');
const FeedbackThumbs = require('../../../components/FeedbackThumbs');
const NotFound = require('../../../components/NotFound');
const FeedbackProvider = require('../../../../providers/contextProvider');
const BreadCrumbs = require('../../../common/BreadCrumbs');
const { sanitizePath } = require('../../../common/URLSanitizer');
const NextStepsCards = require('../../../components/Documentation/components/NextStepCard');
const LiveDemoComponent = require('../../../../utils/liveDemoComponent');
const { trackMelidataPageView } = require('../../../common/Melidata');
const { ModalAPIOrder } = require('../../../components/ModalAPIOrder');
// const PartnerVisibilityCDPSellerRigthSideBar = require('../../../components/Documentation/components/PartnervVisibility/components/RigthSideBarVisibilityPartners');
const { renderMermaid } = require('./mermaid');

const { useEffect, useRef, useState } = React;

const GuidesContextDocRegex = /\/developers\/(pt|es|en)\/(docs|guides)\/(?<docContext>(\w|\d|_|-)*)?/;

const View = (props) => {
  const {
    platform,
    deviceType,
    lang,
    content,
    appVersion,
    history,
    loading,
    landing,
    i18n,
    actualUrl,
    notfound,
    imageVersionSuffix,
    cookieFeedback,
    menuData,
    devsiteImagesPath,
    hiddenSidebar,
    brand,
    coexistenceEnabled,
  } = props;
  MenuUtils.init(menuData, 'guides');
  const menuItems = MenuUtils.getMenuItems(platform.siteId.toLowerCase(), lang);
  const contentContainer = useRef(null);
  const item = MenuUtils.getItemFromURL(
    sanitizePath(actualUrl?.path),
    platform?.siteId?.toLowerCase(),
    lang,
  );
  const hiddeSidebarByItem = MenuUtils.verifyHiddenSidebarItem(item?.url);
  const [htmlContent, setHtmlContent] = useState(content);
  const [activeItem, setActiveItem] = useState(item);

  useEffect(() => {
    if (content) {
      setHtmlContent(content);
    }
  }, [content]);

  useEffect(() => {
    onPageLoad(
      contentContainer,
      setHtmlContent,
      setActiveItem,
      history,
      platform.siteId,
      lang,
    );
    setActiveItem(item);
    renderMermaid();
  }, [htmlContent]);

  useEffect(() => {
    if (landing) {
      goToLocation(contentContainer);
    }
  }, [landing]);

  const changedActiveItem = useRef(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (activeItem && changedActiveItem.current) {
      trackMelidataPageView('/developers/docs', lang, activeItem?.url, 'documentation');
    }
    changedActiveItem.current = true;
  }, [activeItem]);

  function transformImageUri(imageEndpoint) {
    let imageParsed = imageEndpoint;
    // if rebranding: i) adding suffix and ii) changing gif to jpg
    if (brand === 'yellowblue-light') {
      imageParsed = imageParsed.replace(/(\.[\w\d_-]+)$/i, '-rebranding$1');

      if (imageParsed.match(/\.gif$/)) {
        imageParsed = imageParsed.replace(/\.gif$/, '.jpg');
      }
    }
    const versionParam = `v=${imageVersionSuffix}`;
    return `${devsiteImagesPath}${imageParsed.replace(
      /^(\/images\/|images\/)/,
      '',
    )}${imageParsed.indexOf('?') > 0 ? `&${versionParam}` : `?${versionParam}`}`;
  }

  const landingComponent = Landings.getLanding({ ...props, setActiveItem });
  const isLanding = landing === 'sdks' || landing === 'overview';
  const showFeedbackComponentBottom = !landingComponent || landing === 'sdks' || landing === 'overview';
  const validate = actualUrl?.path?.match(/\/landing/g);

  // eslint-disable-next-line no-nested-ternary
  const anchoredMenu = showFeedbackComponentBottom && deviceType !== 'mobile' ? (
    (!validate ? <AnchoredMenu contentSelectorClass=".layout__container" htmlContent={htmlContent} />
      : <AnchoredLanding i18n={i18n} htmlContent={htmlContent} />)
  ) : undefined;

  useEffect(() => {
    if (content || landing) {
      LiveDemoComponent.fillDemoComponents();
    }
  }, [content, landing]);

  const actualDocContext = actualUrl?.path?.match(GuidesContextDocRegex)?.groups
    ?.docContext;
  const removeDomainFromDevSiteUrl = (url) => {
    try {
      return url?.replace(
        /http(s)?:\/\/www.mercadopago.((com.(br|ar|uy|pe|mx|co))|cl)/,
        '',
      );
    } catch {
      return url;
    }
  };
  const urlParser = (url) => {
    try {
      const { pathname } = new URL(url, 'http://basdomain.com');
      const destinyContext = pathname.match(GuidesContextDocRegex)?.groups
        ?.docContext;

      if (!destinyContext || destinyContext === actualDocContext) {
        return removeDomainFromDevSiteUrl(url?.replace('/guides/', '/docs/'));
      }

      const pathToSearch = pathname.replace(
        /\/developers\/(pt|es|en)\/(guides|docs)/gm,
        '/guides',
      );
      const menuItemReference = MenuUtils.getItemFromPathWithContext(
        actualDocContext,
        pathToSearch,
      );
      if (menuItemReference) {
        return `/developers/${lang}${menuItemReference?.url}`;
      }
    } catch (error) {
      console.log('Error parsing ', url);
    }
    return removeDomainFromDevSiteUrl(url);
  };

  const [previousItem, nextItem] = MenuUtils.getNextStepsMenuBased(platform.siteId.toLowerCase(), lang, 'guides', activeItem?.url, activeItem?.is_last_article, i18n);
  const nextStepData = [
    previousItem,
    nextItem,
  ].filter((step) => step);
  return (
    <FeedbackProvider>
      <PageContainer
        {...props}
        setHtmlContent={setHtmlContent}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        menuItems={menuItems}
        footerClassNames={`footer__${landing}`}
        state={props}
        hideSidebar={hiddenSidebar || hiddeSidebarByItem}
      >
        <div name="guides" platform={platform}>
          <Script priority={1} src={`https://http2.mlstatic.com/frontend-assets/dx-devsite/javascripts/prism.js?v=${appVersion}`} />
          <Script priority={1} src="https://http2.mlstatic.com/frontend-assets/dx-devsite/javascripts/mermaid.js" />
          <Script priority={1} preload src="https://http2.mlstatic.com/frontend-assets/dx-devsite/javascripts/svg-pan-zoom.js" />
          <Script src="docs.chunk.js" preload priority={12} />
          <Style href="app-styles.css" />
          <Script src="app.js" preload priority={13} />

          <div>
            {notfound && <div className="docs-not-found__container"><NotFound i18n={i18n} /></div>}
            {landingComponent && !loading && (
              <div ref={contentContainer} id="inner-content">
                {landingComponent}
              </div>
            )}
            {!loading && !landingComponent && htmlContent && !notfound && (
              <div className="docspage_wrapper">
                <article ref={contentContainer} className="layout__main">
                  <div className="layout__container">
                    {htmlContent && htmlContent !== ' ' && (
                      <>
                        {!(hiddenSidebar || hiddeSidebarByItem) && (
                          <BreadCrumbs
                            lang={lang}
                            path={actualUrl.path}
                            platform={platform}
                            i18n={i18n}
                          />
                        )}
                        <div className="layout__doc-container">
                          <Library
                            i18n={i18n}
                            key="unique-key"
                            input={htmlContent}
                            siteId={platform.siteId}
                            lang={lang}
                            transformImageUri={transformImageUri}
                            transformLinkUri={urlParser}
                            assetsPath={devsiteImagesPath}
                            brand={brand}
                          />
                        </div>
                      </>
                    )}
                  </div>
                  {nextStepData && !loading && nextStepData?.length > 0 && (
                    <div className="step-cards-container">
                      {nextStepData?.map((data) => (
                        <NextStepsCards {...data} />
                      ))}
                    </div>
                  )}
                  {showFeedbackComponentBottom && !loading && deviceType === 'mobile' && (
                    <FeedbackThumbs
                      i18n={i18n}
                      actualLocation={actualUrl.href}
                      lang={lang}
                      siteId={platform.siteId}
                      domain={platform.domain}
                      cookieFeedback={cookieFeedback}
                      isOutOfAnchor={deviceType !== 'mobile'}
                      isLanding={isLanding}
                    />
                  )}
                </article>
                <div className="right-sidebar">
                  {showFeedbackComponentBottom
                    && deviceType !== 'mobile'
                    && !loading && (
                      <>
                        <FeedbackThumbs
                          lang={lang}
                          siteId={platform.siteId}
                        />

                        {anchoredMenu}
                        {/* <PartnerVisibilityCDPSellerRigthSideBar i18n={i18n} platform={platform} /> */}
                      </>)}
                </div>
              </div>
            )}
            {loading && (
              <div ref={contentContainer} className="inner-content--empty">
                <ProgressIndicatorCircular modifier="block" size="large" />
              </div>
            )}
          </div>
        </div>
      </PageContainer>

      <ModalAPIOrder
        lang={lang}
        brand={brand}
        siteId={platform?.siteId}
        coexistenceEnabled={coexistenceEnabled}
      />
    </FeedbackProvider>
  );
};

View.propTypes = {
  i18n: PropTypes.shape({
    gettext: PropTypes.func.isRequired,
  }).isRequired,
  platform: PropTypes.shape({
    siteId: PropTypes.string.isRequired,
    domain: PropTypes.string.isRequired,
  }).isRequired,
  actualUrl: PropTypes.shape({
    host: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    fullPath: PropTypes.string.isRequired,
  }).isRequired,
  lang: PropTypes.string.isRequired,
};

/**
 * Inject i18n context as props into View.
 */
module.exports = injectI18n(View);
